import React, { useMemo, useState, useEffect } from "react";
import "jspdf-autotable";
import { useHistory, useLocation, useParams } from "react-router";
import TreeTheme from "react-sortable-tree-theme-minimal";

import axios from "axios";
import { Link } from "react-router-dom";
import SortableTree from "react-sortable-tree";
import { Placeholder } from "semantic-ui-react";
import Swal from "sweetalert2";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import {
  DeleteProgrammeStudyPath,
  getCommonContent,
  GetProgramAssignedOrNotAssignedListCancelToken,
  GetProgrammeStudyPathList,
  ReArrangeStudyPathPhase,
} from "../../../services/ProgramService";
import { exportTableData, handleTableScroll } from "../../../utils/commonFunction";
import PermissionsGate from "../../../utils/permissionGate";
import { TrimText } from "../../common/TrimText";

const StudyPathRearrange = () => {
  const history = useHistory();
  const { id } = useParams();
  const { search: querySearch } = useLocation();
  const query = new URLSearchParams(querySearch);
  const queryVersionId = query.get("versionId");
  const queryProgrammeId = query.get("programmeId");
  const [search, setSearch] = useState("");
  const [duration, setDuration] = useState({arr:[], checkObj:{}});
  const [moduleType, setModuleType] = useState({ arr: [], checkObj: {} })
  const [filterData, setFilterData] = useState([]);
  const [data, setData] = useState(); 
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [renderData, setRenderData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false)
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "order_number",
    sortOrder: "ASC"
})

  useEffect(() => {
    handleTableScroll()
  }, [loading])


  useEffect(() => {
    const filterSource = axios.CancelToken.source();
    const getFilters = async () =>{
      try {
        const res = await getCommonContent(filterSource.token);
        if(res.status==200){
          setFilterData(res?.data.type_course);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);          
        }
      }
    }
    
    getFilters();
    return () => {
      filterSource.cancel('Component unmounted');      
    };
  }, []);

  useEffect(() => {
      const cancelTokenSources = [];

      const getProgramsList = async () => {
        setLoading(true)
    
        cancelTokenSources.forEach(source => {
          source.cancel('New request made');
        });
    
        const source = axios.CancelToken.source();
        cancelTokenSources.push(source);

        try {
          const res = await GetProgramAssignedOrNotAssignedListCancelToken({ PId: queryProgrammeId, type: "assigned",version_id :queryVersionId }, source.token);
          if (res.status === 200) {
            setLoading(false)
            setData(res.data.programs);
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.error(error);
            setLoading(false)
          }
        }
      };
    
      getProgramsList();
  
      return () => {
        cancelTokenSources.forEach(source => {
          source.cancel('Component unmounted');
        });
      };
  }, [refresh]);

  const handleChangeData = (newData) => {
    setRenderData(newData);
};

const handleDragNode = (dragData) => {
    const { isDragging } = dragData;

    if (isDragging === false) {
        setIsDisabled(false);
    }
};

const handleSaveData = () => {
  setIsDisabled(true);
    let array = []
    for(let d of renderData){
      array.push(
        d.id
      )
    }
    let dataToSend = {
      study_paths : array
    }
        ReArrangeStudyPathPhase(dataToSend).then((res)=>{
            if(res.status===200){
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: `${res?.data?.message}`,
                  }).then(() => {
                    setIsDisabled(false)
                    setRefresh(!refresh)
                  });
            }
        }).catch((err)=>{
          setIsDisabled(false)
            console.log(err);            
            Swal.fire({
              icon: "error",
              title: "error",
              text: `${err?.response?.data[0]?.message}`,
            });
        }).finally(()=>{
          setIsDisabled(false)
            setIsDisabled(false)
        })
};

  useEffect(() => {
    const cancelTokenSources = [];

    const getListOfuser = async () => {
      setLoading(true)
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
  
      const apiData = {
        page: tableState.page,
        limit: tableState.perPage,
        key: "order_number",
        sort: tableState.sortOrder,
        search: search,
        programme_id: queryProgrammeId,
        exportStatus: "true",
        version_id : queryVersionId
      };
  
      try {
        const res = await GetProgrammeStudyPathList(apiData);

        if (res.status == 200) {
          const formatData = res.data?.data.map(
            (data) => {
                return {
                    ...data,
                    title:data ? <RenderTitle data={data}/> : "N/A",
                }
            }
          )
          setRenderData(formatData)
          setLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoading(false);
        }
      }
    }

   getListOfuser();

   return () => {
    cancelTokenSources.forEach(source => {
      source.cancel('Component unmounted');
    });
  };
  }, [ search,refresh ]);

  usePermissionGuardRedirect(['pmview']);

  const handlerefresh = () => {
    setRefresh(!refresh);
  };

  const columns = useMemo(() => [
    {
      name: "No.",
      selector: "id",
      sortable: true,
      cell: (row) => (
        <span>{row.id}</span>
      ),
    },
    {
      name: "Name",
      selector: "name",
      sortable: true,
      cell: (row) => (
        <div className="ticket-id">
          {row.name ? <span title={row.name} className="overflow-ellipsis2 as-text-blue">
            {TrimText(row.name, 25)}
          </span> : "-"}
        </div>
      ),
    },

    {
      name: "Core Modules",
      selector: "core_module",
      sortable: true,
      cell: (row) => 
        row.core_module.map((d,i) => (
          <div className="d-flex gap-4 align-items-center">
          <span className="study-path-dot"></span>
          <div className="as-text-blue">{d.name}</div>
          </div>
        )
      ),
    },
    {
      name: "Core Credits",
      selector: "core_credits",
      sortable: true,
      cell: (row) => row.core_credits ? <div title={row.core_credits}>{row.core_credits}</div> : "-"
    },
    {
      name: "Foundational Modules",
      selector: "foundation_module",
      sortable: true,
      cell: (row) =>(
        row.foundation_module.map((d,i) => (
          <div className="d-flex gap-4 align-items-center">
          <span className="study-path-dot"></span>
          <div className="as-text-blue">{d.name}</div>
          </div>
        ))
      )
    },
    {
      name: "Foundational Credits",
      selector: "foundational_credits",
      sortable: true,
      cell: (row) => row?.foundational_credits ? row.foundational_credits : "-",
    },
    {
      name: "Specialised Modules",
      selector: "elective_module",
      sortable: true,
      cell: (row) => (
        row.elective_module.map((d,i) => (
          <div className="d-flex gap-4 align-items-center">
          <span className="study-path-dot"></span>
          <div className="as-text-blue">{d.name}</div>
          </div>
      ))),
    },
    {
      name: "Specialised Credits",
      selector: "elective_credits",
      sortable: true,
      cell: (row) => (row.elective_credits ? <div title={row.elective_credits}>{row.elective_credits}</div> : "-")
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <PermissionsGate
              scopes={["pmcpmedit"]}
              RenderError={() => (
                <button
                  className="btn btn-primary rounded-circle"
                  title="Open"
                  disabled
                >
                  <i className="fal fa-folder-open"></i>
                </button>
              )}
            >
              <Link
                 to={`/program-management-center/programmes/study_path/open/${id}/${row.id}`}
                className="btn btn-primary rounded-circle"
                title="Open"
              >
                <i className="fal fa-folder-open"></i>
              </Link>
            </PermissionsGate>
            <PermissionsGate
              scopes={["pmdelete"]}
              RenderError={() => (
                <button
                  className="btn btn-danger rounded-circle"
                  title="Delete"
                  disabled
                >
                  <i className="fal fa-trash-alt"></i>
                </button>
              )}
            >
              <button
                className="btn btn-danger rounded-circle"
                title="Delete"
                onClick={() => handleDelete(row.id)}
              >
                <i className="fal fa-trash-alt"></i>
              </button>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const handleDelete = (ID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteProgrammeStudyPath({ id: ID })
          .then((res) => {
            Swal.fire("Deleted!", "Your module has been removed.", "success");
            handlerefresh();
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const resetFilter = () => {
    setSearch("");
    setModuleType({ arr: [], checkObj: {} })
    setDuration({ arr: [], checkObj: {} })
  };

  const exportData = (fileType, fileName) => {
    let data;
    const header = ["No.", "Name", "Core Modules", "Core Credits", "Foundational Modules", "Foundational Credits", "Specialised Modules","Specialised Credits"];
    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    const cData = {
      page: tableState.page,
      limit: tableState.perPage,
      key: tableState.sortKey,
      sort: tableState.sortOrder,
      search: search,
      programme_id: queryProgrammeId,
      exportStatus: "true",
      version_id : queryVersionId
    }
    GetProgrammeStudyPathList(cData).then(res => {
      data = res.data?.data;
      data = data?.map((row, ind) => ({
        "No.":row.order_number ? row.order_number : "-",
        "Name": row.name ? row.name : "-",
        "Core Modules" : row.core_module.length ? 
        row.core_module.map((d,i) => (
          d.name
        )) : "-",
        "Core Credits": row.core_credits ? row.core_credits : "-",
        "Foundational Modules" : row?.foundation_module?.length > 0 ? 
        row.foundation_module.map((d,i) => (
          d.name
        )) : "-",
        "Foundational Credits" : row.foundational_credits ? row.foundational_credits : "-",
        "Specialised Modules": row?.elective_module.length > 0
          ? row.elective_module.map(d => d.name).join(", ")
          : "-",
        "Specialised Credits" : row.elective_credits ? row.elective_credits : "-",
      }));
      exportTableData(fileType, fileName, header, data);
      Swal.close();

    }).catch(error => {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
      });
    })
  };

  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="custom-table-div filter-search-icon card card-table-custom">
      <h5 className="mb-4 fw-bold phase-color">Phases</h5>
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <div
                      id="assessment-table-main_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        <input
                          type="search"
                          className=""
                          placeholder="Search"
                          aria-controls="assessment-table-main"
                          onChange={handleSearchFilter}
                          value={search}
                        />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                {/*end of learning method*/}
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={() => resetFilter()}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                </div>
                <div className="files-export-group">
                  <button
                    type="button"
                    className="btn btn-files"
                    onClick={() => {
                      exportData("xlsx", "Study Path");
                    }}
                    title="Export spreadsheet"
                  >
                    <i className="fal fa-file-excel icon"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-files"
                    onClick={() => {
                      exportData("csv", "Study Path");
                    }}
                    title="Export CSV"
                  >
                    <i className="fal fa-file-csv icon"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-files"
                    onClick={() => {
                      exportData("pdf", "Study Path");
                    }}
                    title="Export PDF"
                  >
                    <i className="fal fa-file-pdf icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="search-filter-div-right">
            <div className=" filter-search-bar-blk gap-3">
              <div className="add-ticket-blk button-reset dropdown-comman">
                  <button
                    className="btn btn-primary"
                    title="Re-Arrange"
                    onClick={() => {history.push(`/program-management-center/programmes/versions/study_path?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)}}
                  >
                    <i className="fal fa-random"></i>Re-Arrange
                  </button>
              </div>
              <div className="add-ticket-blk button-reset dropdown-comman">
                  <button
                    className="btn btn-primary"
                    title="Create New"
                    onClick={() => {history.push(`/program-management-center/programmes/versions/study_path?type=create&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)}}
                    >
                    <i className="fal fa-plus"></i>Create New
                  </button>
              </div>
            </div>

          </div>
        </div>
        <div className="tree-wrapper">
                    {loading ? (
                        <SkeletonTicketList />
                    ) : (
                        <SortableTree
                            theme={TreeTheme}
                            className="my-class"
                            isVirtualized={false}
                            treeData={renderData ? renderData : []}
                            onChange={(treeData) => handleChangeData(treeData)}
                            maxDepth={2}
                            onDragStateChanged={(dragData) => handleDragNode(dragData)}
                            style={{
                                padding: "0px",
                                width: "100%",
                            }}
                            canNodeHaveChildren = {(node)=>(node.type===1)}
                            generateNodeProps={(rowInfo) => {
                                const { node, parentNode } = rowInfo;
                                return {
                                    canDrop :node.type===0 ? true : false,
                                    class:
                                        node.type === 1
                                            ? "main-category-node just1"
                                            : node.type === 0
                                                ? "sub-category-node just1"
                                                : "item-node just1",
                                    buttons: [
                                        <>
                                        <div className="drag-option-container"> 
                                                
                                                <div className="assessment-08 btn-dropdown-grp">
                                                    <div className="as-buttons">
                                                        <PermissionsGate
                                                        scopes={["pmcpmedit"]}
                                                        RenderError={() => (
                                                            <button
                                                            className="btn btn-primary rounded-circle"
                                                            title="Open"
                                                            disabled
                                                            >
                                                            <i className="fal fa-folder-open"></i>
                                                            </button>
                                                        )}
                                                        >
                                                        <Link
                                                             to={`/program-management-center/programmes/study_path/open/${id}/${rowInfo.node.id}`}
                                                            className="btn btn-primary rounded-circle"
                                                            title="Open"
                                                            >
                                                            <i className="fal fa-folder-open"></i>
                                                        </Link>
                                                        </PermissionsGate>
                                                        <PermissionsGate
                                                            scopes={["pmcstudypathdelete"]}
                                                            RenderError={() => (
                                                              <button
                                                                className="btn btn-danger rounded-circle"
                                                                title="Delete"
                                                                disabled
                                                              >
                                                                <i className="fal fa-trash-alt"></i>
                                                              </button>
                                                            )}
                                                          >
                                                        <button
                                                            className="btn btn-danger rounded-circle"
                                                            title="Delete"
                                                            onClick={() => handleDelete(rowInfo.node?.id)}
                                                            >
                                                            <i className="fal fa-trash-alt"></i>
                                                        </button>
                                                        </PermissionsGate>
                                                    </div>
                                                    </div>                           
                                            </div>
                                                            </>
                                    ],
                                    style: { borderRadius: "10px", width: "100%" },
                                };
                            }}
                            placeholderRenderer={Placeholder}
                        />
                    )}
                </div>
      <div className="form-group form-group-save-cancel mt-3 mb-0">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => {
                        handleSaveData();
                    }}
                    title="Save"
                    disabled={isDisabled}
                >
                    {isDisabled === false ? <i className="fal fa-save"></i> : <i className="fas fa-cog fa-spin"></i>}
                    Save
                </button>
                <button
                    className="btn btn-close btn-danger"
                    type="button"
                    title="Cancel"
                    onClick={() => (setRefresh(!refresh))}
                >
                    <i className="fal fa-times"></i>Cancel
                </button>
            </div>
      </div>
    </div>
  );
};

export default StudyPathRearrange;

const RenderTitle = ({data}) => {
    return (
        <div className="d-flex justify-content-between">
        <p className="assembly-list-title" title={data.name}>
         <i className="fal fa-list mr-2"></i>
        <span className="as-text-blue">
            {TrimText(data.name)}    
        </span>
      </p>
      <div className="d-flex gap-5">

      <span>
        <span className="fw-bold fs-14">Core Modules: </span> <br/> <span className="fs-14">{data.core_module?.length} Modules {data.core_credits} Credits</span>
      </span>
      <span>
        <span className="fw-bold fs-14">Foundational Modules: </span> <br/> <span className="fs-14">{data.foundation_module?.length} Modules {data.foundational_credits} Credits</span>
      </span>
      <span>
            <span className="fw-bold fs-14">Specialised Modules: </span> <br/> <span className="fs-14">{data.elective_module?.length} Modules {data.elective_credits} Credits</span>
      </span>
      </div>
        </div>
    )
}